// extracted by mini-css-extract-plugin
module.exports = {"heroFAQ":"style-module--heroFAQ--3a2Va","text":"style-module--text--398Lr"};